import React, { Component } from "react";
import {
  Accordion as ExpansionPanel,
  AccordionDetails as ExpansionPanelDetails,
  Switch,
  FormControlLabel,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import {
  AddCircleOutline,
  RemoveCircleOutline,
  Replay,
} from "@material-ui/icons";
import { connect } from "react-redux";

import VehicleRows from "./VehicleRows";
import VehicleSettings from "./settings/VehicleSettings";

import { NOTIFY, ALERTS } from "common/consts";
import { API_Map } from "apihandler/Map";
import { commonJs } from "common/common";
import { MAP_ACTIONS } from "actions/MapActions";
import { PAGE_ACTIONS } from "actions/PageActions";
import { COMMON_ACTIONS } from "actions/CommonActions";
import { TRACK_ACTIONS } from "actions/TrackActions";

import "./vehiclelist.css";

class VehicleList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detailedUi: true,
    };
  }

  loadExpandIcon = () => {
    return <AddCircleOutline />;
  };

  loadMinimizeIcon = () => {
    return <RemoveCircleOutline />;
  };

  hideAllGroupVehicle = () => {
    // this.setState({
    //   visible: !this.state.visible
    // });
    console.log("hideAllGroupVehicle...");
  };

  reloadVehicles = () => {
    // Reset All
    this.props.setLoading({
      loading: true,
    });
    this.props.setVehicles({
      vehicles: [],
    });
    this.props.resetTrackData({
      routeDetails: {},
      routePoints: [],
      routeSummary: [],
      trackBottomBar: false,
    });
    this.loadVehicles(true);
  };

  loadVehicles = async (reset = false) => {
    const self = this;
    const opts = {};
    opts.pageNo = 0;
    opts.pageLength = 100000;
    opts.orderBy = "ASC";
    opts.sortColumn = "";
    API_Map.getAllVehicles(opts)
      .then((res) => {
        console.log("Groups: loadVehicles");
        self.props.setVehicles({
          vehicles: res,
        });
        if (reset) {
          // Reset temp data as well
          self.props.resetVehicles({
            vehicles: res,
          });
          self.props.setLoading({ loading: false });
        }
      })
      .catch((err) => {
        self.props.setLoading({ loading: false });
        err = err.toString();
        if (err.indexOf("Network Error") > -1) {
          commonJs.showNotify(self.props, NOTIFY.WARNING, ALERTS.NO_INTERNET);
        } else {
          commonJs.showNotify(
            self.props,
            NOTIFY.WARNING,
            ALERTS.INTERNAL_SERVER_ERROR
          );
        }
      });
  };

  onVehicleScrolling = () => {
    console.log("onVehicleScrolling");
  };

  changeVehicleUi = () => {
    const { detailedUi } = this.state;
    this.setState({
      detailedUi: !detailedUi,
    });
  };

  loadReloadIcon = () => {
    return <Replay />;
  };

  render() {
    const {
      tmpVehicles,
      filteredVehicles,
      signalFilter,
      loadStatusFilter,
    } = this.props.mapReducer;

    const { vehicleEditPopup, loading } = this.props.pageReducer;

    var vlist = tmpVehicles;
    if (filteredVehicles !== undefined && filteredVehicles.length > 0) {
      vlist = filteredVehicles;
    }

    const vehicles = commonJs.getVehicleFilteredList(
      vlist,
      signalFilter,
      loadStatusFilter
    );

    var vcount = vehicles.length;

    const { updateMapRegion, switchTab, shareVehicle } = this.props;

    const { detailedUi } = this.state;

    console.log("vehicle list: render", vcount, loading);

    return (
      <React.Fragment>
        <div className="vehiclelist-header">
          <div className="vehiclelist-title">Vehicles List ({vcount})</div>
          <div className="reload-vehicles">
            <Tooltip title="Reload">
              <IconButton onClick={this.reloadVehicles}>
                {this.loadReloadIcon()}
              </IconButton>
            </Tooltip>
          </div>
          <FormControlLabel
            className="detailedview"
            control={
              <Switch
                checked={detailedUi}
                onChange={this.changeVehicleUi}
                color="primary"
                inputProps={{ "aria-label": "primary checkbox" }}
                size="small"
              />
            }
            label="Detailed View"
          />
        </div>

        {/* Vehicles List */}
        <div id="vehicleList">
          <ExpansionPanel
            expanded={true}
            classes={{
              root: "expansionPanel open",
            }}
          >
            <ExpansionPanelDetails className="expansionPanelDetails">
              <div
                style={{
                  height: "calc(100vh - 208px)",
                  width: "100%",
                }}
                className="rowlist"
              >
                {loading ? (
                  <div
                    style={{
                      paddingTop: 2,
                      paddingBottom: 2,
                      paddingLeft: 6,
                      paddingRight: 6,
                    }}
                  >
                    {/* Loading Gif */}
                    <div className="placeholder">
                      <div className="animated-background" />
                    </div>
                    <div className="placeholder">
                      <div className="animated-background" />
                    </div>
                    <div className="placeholder">
                      <div className="animated-background" />
                    </div>
                    <div className="placeholder">
                      <div className="animated-background" />
                    </div>
                    <div className="placeholder">
                      <div className="animated-background" />
                    </div>
                    <div className="placeholder">
                      <div className="animated-background" />
                    </div>
                    <div className="placeholder">
                      <div className="animated-background" />
                    </div>
                    <div className="placeholder">
                      <div className="animated-background" />
                    </div>
                    <div className="placeholder">
                      <div className="animated-background" />
                    </div>
                    <div className="placeholder">
                      <div className="animated-background" />
                    </div>
                    <div className="placeholder">
                      <div className="animated-background" />
                    </div>
                    <div className="placeholder">
                      <div className="animated-background" />
                    </div>
                    <div className="placeholder">
                      <div className="animated-background" />
                    </div>
                  </div>
                ) : (
                  <VehicleRows
                    shareVehicle={shareVehicle}
                    updateMapRegion={updateMapRegion}
                    switchTab={switchTab}
                    detailedUi={detailedUi}
                  />
                )}
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </div>

        {/* Vehicle Settings */}
        {vehicleEditPopup && (
          <VehicleSettings loadVehicles={this.reloadVehicles} />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    mapReducer: state.mapReducer,
    pageReducer: state.pageReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setMapInit: (values) => {
      dispatch({
        type: MAP_ACTIONS.INITIALIZE_MAP,
        values,
      });
    },
    setSelectedVehicle: (values) => {
      dispatch({
        type: MAP_ACTIONS.SELECT_VEHICLE,
        values,
      });
    },
    setLoading: (values) => {
      dispatch({
        type: PAGE_ACTIONS.SET_MAP_LOADING,
        values,
      });
    },
    resetVehicles: (values) => {
      dispatch({
        type: MAP_ACTIONS.RESET_VEHICLES,
        values,
      });
    },
    setVehicles: (values) => {
      dispatch({
        type: COMMON_ACTIONS.SET_VEHICLES,
        values,
      });
    },
    resetTrackData: (values) => {
      console.log("resetTrackData");
      dispatch({
        type: TRACK_ACTIONS.SET_TRACK_DATA,
        values,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VehicleList);
